import type { PostContentObjectDetail, PostContentObjectList } from 'models';
import { useCallback, useMemo } from 'react';
import { useConfirmDelete } from '../../../hooks';
import { useDeletePostContentObjectMutation } from '../../../queries';

export const useDeletePostConfirmModal = () => {
  const { mutateAsync: deletePost } = useDeletePostContentObjectMutation();
  const { confirm, contextHolder } = useConfirmDelete();

  const confirmDelete = useCallback(
    ({
      item,
      onSuccess,
      title,
    }: {
      item: PostContentObjectDetail | PostContentObjectList;
      onSuccess: () => void;
      title: string;
    }) => {
      confirm({
        async onOk() {
          await deletePost(
            { contentObject: item },
            {
              onSuccess,
            },
          );
        },
        title,
      });
    },
    [confirm, deletePost],
  );

  return useMemo(
    () => ({
      confirm: confirmDelete,
      contextHolder,
    }),
    [confirmDelete, contextHolder],
  );
};
